import type { Ref } from 'vue'

import { isRef, onMounted, onUnmounted, ref } from 'vue'

/** 观测目标元素，并在首次进入视口后保持显现状态。 */
export const useScrollReveal = (
  targetOrThreshold: number | Ref<HTMLElement | null> = 0.1,
  threshold = 0.1
) => {
  let targetRef: Ref<HTMLElement | null>
  let actualThreshold = threshold
  let observer: IntersectionObserver | undefined

  if (isRef(targetOrThreshold)) {
    targetRef = targetOrThreshold
  } else {
    targetRef = ref(null)
    if (typeof targetOrThreshold === 'number') {
      actualThreshold = targetOrThreshold
    }
  }

  const isVisible = ref(false)
  const isReady = ref(false)

  onMounted(() => {
    const target = targetRef.value
    if (!target) {
      isVisible.value = true
      return
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
      isReady.value = true
      isVisible.value = true
      return
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          isVisible.value = true
          observer?.unobserve(entry.target)
        })
      },
      { threshold: actualThreshold }
    )

    isReady.value = true
    observer.observe(target)
  })

  onUnmounted(() => observer?.disconnect())

  return {
    targetRef,
    isReady,
    isVisible,
  }
}
